import { observer } from "mobx-react";
import React from "react";
import { Link, useNavigate } from "react-router";
import styled from "styled-components";

import Navigation from "@client/components/modules/DetailsPage/Navigation";
import DropdownUser from "@client/components/ui/DropdownUser";
import userStore from "@client/stores/LicensorStore";

import logoImage from "./images/logo.svg";
import backgroundImage from "./images/star-bg.jpg";

const Wrapper = styled.div`
  display: flex;
  height: 64px;
  background: url("${backgroundImage}");
  align-items: center;
  padding-right: 22px;
  justify-content: space-between;
`;
const Logo = styled(Link)`
  width: 240px;
  height: 48px;
  background: url("${logoImage}") no-repeat;
  cursor: pointer;
`;
const DropdownUserStyled = styled(DropdownUser)`
  margin-left: 16px;
`;
const Menu = styled.div`
  display: flex;
  align-items: center;
`;
const User = styled.div`
  display: flex;
  align-items: center;
`;

type Props = {
  onNavigate: (path: string) => void;
};

@observer
class DetailsPageHeader extends React.Component<Props> {
  async handleUserItemClick(item: { value: string }) {
    switch (item.value) {
      case "signout":
        await userStore.logout();
        this.props.onNavigate("/login");
        break;
      default:
    }
  }

  render() {
    return (
      <Wrapper>
        <Menu>
          <Navigation tokenInfo={userStore.tokenInfo} />
          <Logo to="/" />
        </Menu>
        <User>
          <DropdownUserStyled
            white
            user={userStore.tokenInfo?.user}
            onItemClick={(item: { value: string }) => {
              this.handleUserItemClick(item);
            }}
          />
        </User>
      </Wrapper>
    );
  }
}

function DetailsPageHeaderWithNavigate() {
  const navigate = useNavigate();
  return <DetailsPageHeader onNavigate={navigate} />;
}

export default DetailsPageHeaderWithNavigate;
